import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { getToken, removeToken } from '@/utils/auth'
import { onlyLanguage } from "@/utils/storage";
import errorCode from '@/utils/errorCode'
import router from '@/router'


axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.BASE_API,
  // 超时
  timeout: 100000,
  // 次数
  retry: 3,
  // 间隙
  retryDelay: 1000

})
const that = new Vue()
// request拦截器


service.interceptors.request.use(config => {
  // 是否需要设置 token
  config.headers['language'] = store.state.app.language;
  config.headers['channelcode'] = store.state.order.channelcode;
  const isToken = (config.headers || {}).isToken === false
  if (getToken() && !isToken) {
    config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    // config.headers['token'] = getepayToken() || ''
    // config.headers['ts'] = encrypt(+new Date(), key, iv)
    // config.headers['version'] = getversion()
    // config.headers['os'] = 'h5'
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            if (value[key] !== null && typeof (value[key]) !== 'undefined') {
              let params = propName + '[' + key + ']';
              let subPart = encodeURIComponent(params) + '=';
              url += subPart + encodeURIComponent(value[key]) + '&';
            }
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  if (typeof (res.data) == 'object') {

    // 未设置状态码则默认成功状态
    const code = res.data.code || 0;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']

    if (code === 9 || code === 103 || code === 104) {
      // store.dispatch('LogOut').then(() => {
      onlyLanguage()
      removeToken()
      if (router.currentRoute.path !== '/home') {
        router.replace("/login");
      }
      // location.reload()// 为了重新实例化vue-router对象 避免bug
      // })

      return Promise.reject({ code, err: 'Sesi telah kedaluwarsa, silakan masuk lagi' })
    } else if (code === 500) {
      that.$toast({
        msg
      })
      return Promise.reject(new Error(msg))
    } else if (code !== 0) {
      that.$toast(`${msg}`)
      return Promise.reject(new Error(msg))
    } else if (res.request.responseType == 'blob') {
      return res
    } else if (code === 0) {

      return res.data
    } else {
      that.$toast(`${msg}`)
    }


  }
  // if (typeof (res.data) == 'string') {

  //   return JSON.parse(decrypt(
  //     res.data,
  //     window.localStorage.getItem("SET_KEY"),
  //     window.localStorage.getItem("SET_V")
  //   ))
  // }


},

  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = 'Koneksi antarmuka ujung belakang abnormal';
    }
    else if (message.includes("timeout")) {
      message = 'Batas waktu permintaan antarmuka sistem';
    }
    else if (message.includes("Request failed with status code")) {
      message = 'Tampilan sistem' + '"' + message.substr(message.length - 3) + '"' + 'abnormal';
    }
    that.$toast({
      message: message,
      duration: 3000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js